import { Link } from "react-router-dom";
import { ArrowRight, Clock } from "lucide-react";
import PageHero from "@/components/site/PageHero";
import Reveal from "@/components/site/Reveal";
import { INSIGHTS } from "@/lib/insights";

export default function InsightsIndexPage() {
  const [featured, ...rest] = INSIGHTS;
  return (
    <div data-testid="insights-index">
      <PageHero
        eyebrow="Groman Insights"
        title="Practical HR intelligence for leaders who don't have time for theory."
        subtitle="Compliance frameworks, workforce strategy, and government contracting playbooks — written by senior HR practitioners, for the people who actually run organizations."
        breadcrumbs={[{ label: "Home", to: "/" }, { label: "Insights" }]}
      />

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 lg:py-24">
        <Reveal>
          <Link
            to={`/insights/${featured.slug}`}
            data-testid={`insight-featured-${featured.slug}`}
            className="group grid lg:grid-cols-12 gap-8 border border-gray-200 bg-white hover:border-gold transition-colors"
          >
            <div className="lg:col-span-7 aspect-[16/10] lg:aspect-auto overflow-hidden bg-offwhite">
              <img src={featured.image} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
            </div>
            <div className="lg:col-span-5 p-8 lg:p-10 flex flex-col justify-center">
              <div className="font-mono text-[10px] uppercase tracking-[0.24em] text-gold mb-4">
                Featured · {featured.category} · {featured.read}
              </div>
              <h2 className="font-heading text-2xl md:text-4xl font-semibold text-charcoal leading-tight group-hover:text-gold transition-colors">
                {featured.title}
              </h2>
              <p className="mt-4 text-charcoal-soft leading-relaxed">{featured.excerpt}</p>
              <div className="mt-8 inline-flex items-center gap-2 text-sm font-medium text-charcoal">
                Read insight <ArrowRight className="w-4 h-4" />
              </div>
            </div>
          </Link>
        </Reveal>

        <div className="mt-20 grid md:grid-cols-2 gap-6">
          {rest.map((p, i) => (
            <Reveal key={p.slug} delay={i * 0.08}>
              <Link
                to={`/insights/${p.slug}`}
                data-testid={`insight-card-${p.slug}`}
                className="group border border-gray-200 bg-white hover:border-gold transition-colors block h-full"
              >
                <div className="aspect-[16/9] overflow-hidden bg-offwhite">
                  <img src={p.thumbnail} alt="" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
                </div>
                <div className="p-8">
                  <div className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.24em] text-charcoal-soft">
                    <span className="text-gold">{p.category}</span>
                    <span>·</span>
                    <span className="flex items-center gap-1"><Clock className="w-3 h-3" />{p.read}</span>
                  </div>
                  <h3 className="mt-5 font-heading text-xl font-medium text-charcoal group-hover:text-gold transition-colors leading-snug">
                    {p.title}
                  </h3>
                  <p className="mt-3 text-sm text-charcoal-soft leading-relaxed">{p.excerpt}</p>
                  <div className="mt-8 inline-flex items-center gap-2 text-xs font-mono uppercase tracking-[0.24em] text-charcoal">
                    Read insight <ArrowRight className="w-3.5 h-3.5" />
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>
    </div>
  );
}
